














import { Vue, Component } from "vue-property-decorator";
import { Roles } from "@/utils/check-access-to-route";
import InstructionsCollection from "@/components/Instructions/InstructionsCollection.vue";
import { isRoot, currentUserIsCompanyOwner } from "@/plugins/roles";
import Error from "@/views/errors/Error.vue";
import { instructions, IInstruction } from "@/services/instructions";

@Component({
  components: { Error, InstructionsCollection }
})
export default class Instructions extends Vue {
  getInstructionById(id: number) {
    return this.instructionsList?.find(el => el.id === id);
  }

  get instructionsList() {
    return instructions;
  }

  get root() {
    return isRoot();
  }

  get documentManager() {
    return this.$store.getters.roles.includes("document_manager");
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get isCompanyOwner() {
    return currentUserIsCompanyOwner();
  }

  get learningRequestManager() {
    return this.$store.getters.roles.includes("learning_request_manager");
  }
  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get myObjectLength() {
    return Object.keys(this.collect.users).length;
  }

  get collect() {
    return {
      users: {
        closeAccept: this.getInstructionById(1),
        howToSetUserRole: this.getInstructionById(1.1),
        userRole: this.getInstructionById(1.2),
        userReset: this.getInstructionById(1.3),
        userInvite: this.getInstructionById(1.4),
        userInactive: this.getInstructionById(1.5),
        userStudents: this.getInstructionById(1.6)
      },
      courses: {
        howAddLecture: this.getInstructionById(2),
        howAddTest: this.getInstructionById(2.1),
        howCopyQuestions: this.getInstructionById(2.2),
        howToSetTestToCourse: this.getInstructionById(2.3),
        testedTest: this.getInstructionById(2.4),
        commentsToQuestionTest: this.getInstructionById(2.5),
        howAddPractice: this.getInstructionById(2.6),
        ScormCourses: this.getInstructionById(2.7),
        howCreateNewCourse: this.getInstructionById(2.8)
      },
      records: {
        howAddRecords: this.getInstructionById(3)
      },
      webinars: {
        howToCreateWebinars: this.getInstructionById(4),
        howToGetWebinarsRecord: this.getInstructionById(4.1)
      },
      requests: {
        howToAddRequest: this.getInstructionById(5)
      },
      accounting: {
        howToCreateAgreement: this.getInstructionById(6),
        howToCreateBill: this.getInstructionById(6.1),
        howToSetActionsToAgreement: this.getInstructionById(6.2)
      }
    };
  }

  get formId() {
    return {
      name: "instructionsItems",
      value: {
        access: [
          Roles.CompanyOwner,
          Roles.ContentManager,
          Roles.DocumentManager,
          Roles.LearningRequestManager,
          Roles.Root
        ],

        info: [
          {
            title: `${this.$tc(this.$translate.Users)}`,
            value: this.collect.users
          },
          {
            title: `${this.$tc(this.$translate.Courses)}`,
            value: this.collect.courses
          },
          {
            title: `${this.$tc(this.$translate.Records)}`,
            value: this.collect.records
          },
          {
            title: `${this.$tc(this.$translate.Webinars)}`,
            value: this.collect.webinars
          },
          {
            title: `${this.$tc(this.$translate.LearningRequests)}`,
            value: this.collect.requests
          },
          {
            title: `${this.$tc(this.$translate.Accounting)}`,
            value: this.collect.accounting
          }
        ]
      }
    };
  }

  checkAccess() {
    if (
      !this.documentManager &&
      !this.root &&
      !this.isCompanyOwner &&
      !this.learningRequestManager &&
      !this.contentManager
    ) {
      this.$router.push({ name: "error" });
    }
  }

  mounted() {
    this.checkAccess();
  }
}
